import * as fromDatatype from '../datatype-library';

export interface bl_alg_cc_template_message_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  msg_type: fromDatatype.VarcharDatatypeInterface;
  template_type: fromDatatype.VarcharDatatypeInterface;
  channel_type: fromDatatype.VarcharDatatypeInterface;
  body: fromDatatype.VarcharDatatypeInterface;
  msg_status: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  start_date: fromDatatype.TimestampTzDatatypeInterface;
  expiry_date: fromDatatype.TimestampTzDatatypeInterface;
}

export class bl_alg_cc_template_message_hdr_RowClass
  implements bl_alg_cc_template_message_hdr_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  msg_type: fromDatatype.VarcharDatatypeInterface;
  template_type: fromDatatype.VarcharDatatypeInterface;
  channel_type: fromDatatype.VarcharDatatypeInterface;
  body: fromDatatype.VarcharDatatypeInterface;
  msg_status: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  start_date: fromDatatype.TimestampTzDatatypeInterface;
  expiry_date: fromDatatype.TimestampTzDatatypeInterface;
}
